import { TreeViewFilterBase } from "./Base/TreeViewFilterBase";
import { ITreeViewFilter } from "./ITreeViewFilter";
import { ITreeNodeModel } from "../../Models/Interfaces/ITreeNodeModel";


export class DateLevelFilter extends TreeViewFilterBase implements ITreeViewFilter {

    filterModel(flatModel: ITreeNodeModel[],
        searchTerm: string,
        hasIsDeleted?: boolean,
        useGrouping?: boolean) {

        this.setAllInvisible(flatModel);
        let notDeletedNodes = this.filterDeleted(flatModel, hasIsDeleted);

        searchTerm = searchTerm.toLocaleLowerCase();
        let filteredNodes = notDeletedNodes.filter(n => {
            let dateValue = n.businessModel.text as string;
            if (dateValue && dateValue.toLocaleLowerCase().indexOf(searchTerm) > -1) {
                return true;
            }
            return false;
        });

        // Set filteredNodes visible
        filteredNodes.forEach(n => n.visible = true);

        // Set parents of filtered Nodes visible - also this has the advantage that we dont have to checkt
        // if a node is already in the filtered model. Much simpler code.
        for (let node of filteredNodes) {
            node.visible = true;
            this.setParentsVisible(node);
            this.setChildrenVisible(node);
        }
    }
}